import { OnChangeValue } from 'react-select';
import { ViewValues } from '@g17eco/types/surveyOverview';
  import { QUESTION } from '@constants/terminology';
import { Option, SelectFactory, SelectTypes } from '@g17eco/molecules/select/SelectFactory';
import { Materiality } from '@g17eco/types/initiative';
import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';

const materialityOptions = [
  { label: 'Low', value: Materiality.Low },
  { label: 'Medium', value: Materiality.Medium },
  { label: 'High', value: Materiality.High },
];

type ScopeTypeOption = Option<ViewValues>;

interface SurveyCardsFilterProps {
  options: ScopeTypeOption[];
  selectedView: ViewValues;
  setSelectedView: (value: ViewValues) => void;
  filterByMateriality?: string[];
  updateFilterMateriality?: (value: string[]) => void;
  hasMateriality: boolean;
}

export const SurveyCardsFilter = ({
  options,
  selectedView,
  setSelectedView,
  filterByMateriality = [],
  updateFilterMateriality,
  hasMateriality,
}: SurveyCardsFilterProps) => {
  const value = options.find((option) => option.value === selectedView);

  const updateView = (option: OnChangeValue<ScopeTypeOption, false>) => {
    if (option?.value !== ViewValues.Sdg && updateFilterMateriality) {
      updateFilterMateriality([]);
    }
    setSelectedView(option?.value ?? selectedView);
  }

  return (
    <div className='d-flex flex-grow-1 justify-content-end gap-3'>
      {selectedView === ViewValues.Sdg && updateFilterMateriality ? (
        <div className='col-4'>
          <SimpleTooltip
            text={
              !hasMateriality
                ? 'Select your industry by going to ‘admin’ then ‘account settings’ to enable materiality'
                : undefined
            }
          >
            <SelectFactory
              selectType={SelectTypes.MultipleSelect}
              placeholder={'Filter by materiality'}
              options={materialityOptions}
              values={filterByMateriality}
              onChange={updateFilterMateriality}
              isDisabled={!hasMateriality}
            />
          </SimpleTooltip>
        </div>
      ) : null}

      <div className='col-5' data-testid='survey-scopes-switcher'>
        <SelectFactory<ViewValues>
          selectType={SelectTypes.SingleSelect}
          placeholder={`Select View ${QUESTION.CAPITALIZED_PLURAL} By`}
          options={options}
          value={value ?? null}
          onChange={updateView}
          isSearchable={false}
        />
      </div>
    </div>
  );
};
